import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import PrpBadge from '../../../../assets/icons/PrpBadge';
import { PRIMARY_COLOR } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

import FirstTimeShiftBadge from './FirstTimeShiftBadge';

const cardBadgeSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: '4px',
  py: '2px',
  borderRadius: '100px',
  backgroundColor: PRIMARY_COLOR[70],
  color: '#FFFFFF',
  fontFamily: PRIMARY_FONT[700],
  fontSize: '9px',
  lineHeight: '12px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

const RosterBadges = ({
  isPriorityResourcePool,
  firstTimeWorkingThisCustomer,
  compact = false,
  card = false,
  sx,
}) => {
  if (!isPriorityResourcePool && firstTimeWorkingThisCustomer !== true) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: card ? '4px' : '8px',
        marginTop: '2px',
        ...sx,
      }}
    >
      {isPriorityResourcePool && (card ? <Box sx={cardBadgeSx}>PRP</Box> : <PrpBadge />)}
      {firstTimeWorkingThisCustomer === true && (
        <FirstTimeShiftBadge compact={compact} card={card} />
      )}
    </Box>
  );
};

RosterBadges.propTypes = {
  isPriorityResourcePool: PropTypes.bool,
  firstTimeWorkingThisCustomer: PropTypes.bool,
  compact: PropTypes.bool,
  card: PropTypes.bool,
  sx: PropTypes.shape({}),
};

export default RosterBadges;
